import { authService } from '@/services/auth.js';

export type Code = { code: string; label: string };
export type CodeDomain = { domain: string; codes: Code[] };

const SERVICE_ENDPOINTS: Record<string, string> = {
  ac: '/api/ac/v1/codes',
  assets: '/api/assets/v1/codes',
};

class CodesService {
  private _cache = new Map<string, CodeDomain[]>();

  private async _authHeaders(): Promise<Record<string, string>> {
    await authService.ensureValidToken();
    return { Authorization: `Bearer ${authService.getToken()!}` };
  }

  private async _fetchService(prefix: string): Promise<CodeDomain[]> {
    if (this._cache.has(prefix)) return this._cache.get(prefix)!;

    const url = SERVICE_ENDPOINTS[prefix];
    if (!url) throw new Error(`No codes endpoint registered for prefix: ${prefix}`);

    const res = await fetch(url, { headers: await this._authHeaders() });
    if (!res.ok) throw new Error(`Failed to load codes for ${prefix}: ${res.status}`);

    const domains: CodeDomain[] = await res.json();
    this._cache.set(prefix, domains);
    return domains;
  }

  async getDomain(domain: string): Promise<Code[]> {
    const prefix = domain.split('.')[0];
    const domains = await this._fetchService(prefix);
    return domains.find(d => d.domain === domain)?.codes ?? [];
  }
}

export const codesService = new CodesService();